<h2 mat-dialog-title class="auditTrain-heading"><a style="color: gray; font-size: 22px;font-family: sans-serif;"><b>Revised Letter</b></a>
</h2>
<div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The
              following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
<div class="row">
    <div class="form-horizontal" style="padding: 15px;padding-left: 30px;">
        <div class="row" style="padding-top:7px;">
            <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Upload Revised Letter</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="File" #fileInput id="" name="file" (change)="AttachRevisedLetter($event)"
                             class="form-control"
                             *ngIf="RevisedLetterList.RevisedLetterAttachmentName == ''"
                             accept=".pdf" style="width: 80%">
                      <span *ngIf="RevisedLetterList.RevisedLetterAttachmentName == ''">
                        No Attachments
                      </span>
                      <span>
                        <a (click)="GetAttachmentbyAttachmentID(RevisedLetterList.RevisedLetterAttachmentID,'LetterGenerated')"
                           style="cursor:pointer;color: blue;">{{RevisedLetterList.RevisedLetterAttachmentName}}</a>
                      </span>
                      <span style="color: blue; cursor: pointer; padding-left: 10px;"
                            *ngIf="RevisedLetterList.RevisedLetterAttachmentName != ''"
                            (click)="DeleteRevisedLetter()" class="pi pi-trash"></span>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
        <button type="button" class="btn btn-primary auditTrain-btn"
        (click)="UploadRevisedLetter()">Upload</button>
        <!--  -->
    <button type="button" class="btn btn-primary auditTrain-btn"
        (click)="closeDialog()">Close</button>
</div>
<br>

<div *ngIf="isLoading" class="overlay">
  <p-progressSpinner styleClass="spinner" [style]="{width: '100px', height: '100px'}"></p-progressSpinner>
</div>
